import * as React from "react";
import { Form, Item, Input, Button, Text } from "native-base";
import { currentLanguage } from "../../translations/CurrentLanguage";

import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import translation from "../.././translations/translation";
import LocalizedStrings from "react-native-localization";
let strings = new LocalizedStrings(translation);
// TODO: styles based from props
const EmailFormComponent = props => {
  strings.setLanguage(currentLanguage().companyLanguage);

  return (
    <Form style={{ width: "100%" }}>
      <Item
        regular
        error={props.emailError}
        style={{ backgroundColor: "white", marginBottom: 12 }}
      >
        <Icon active name="account" size={22} color="#64748b" />
        <Input
          placeholder={strings.Name}
          value={props.userName}
          onChangeText={text => props.onNameChange(text)}
        />
      </Item>
      <Item
        regular
        error={props.emailError}
        style={{ backgroundColor: "white", marginBottom: 12 }}
      >
        <Icon active name="lock-open" size={22} color="#64748b" />
        <Input
          keyboardType="numeric"
          placeholder={strings.Pin}
          value={props.pin}
          onChangeText={text => props.onPinChange(text)}
          secureTextEntry={props.securityPinStatus}
        />
        <Icon
          active
          name={props.securityPinStatus ? "eye-off" : "eye"}
          size={22}
          color="#64748b"
          onPress={props.onPinSecurityStatus}
        />
      </Item>
      <Item
        regular
        error={props.passwordError}
        style={{ backgroundColor: "white", marginBottom: 12 }}
      >
        <Icon active name="lock-open" size={22} color="#64748b" />
        <Input
          placeholder={strings.ConfirmPin}
          value={props.confirmPin}
          onChangeText={text => props.onConfirmPinChange(text)}
          keyboardType="numeric"
          secureTextEntry={props.securityConfirmPinStatus}
        />
        <Icon
          active
          name={props.securityConfirmPinStatus ? "eye-off" : "eye"}
          size={22}
          color="#64748b"
          onPress={props.onConfirmPinSecurityStatus}
        />
      </Item>
      <Button
        block
        onPress={() => props.onSubmit()}
        style={{ backgroundColor: "#2563eb", height: 48, marginTop: 4 }}
      >
        <Text>{props.submitText}</Text>
      </Button>
    </Form>
  );
};

export default EmailFormComponent;
